import React from 'react';
import {
    withStyles,
    Modal,
    Grid,
    ButtonBase,
    IconButton,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Upload } from 'antd-mobile'

const ICON_FACE = require("../../images/icons/biaoqing.png");

let FACEICONSNAME = ['[龇牙]', '[调皮]', '[流汗]', '[偷笑]', '[再见]', '[敲打]', '[擦汗]', '[猪头]', '[玫瑰]', '[流泪]', '[大哭]',
    '[嘘]', '[酷]', '[抓狂]', '[委屈]', '[便便]', '[炸弹]', '[菜刀]', '[可爱]', '[色]',
    '[害羞]', '[得意]', '[吐]', '[微笑]', '[怒]', '[尴尬]', '[惊恐]', '[冷汗]', '[爱心]', '[示爱]',
    '[白眼]', '[傲慢]', '[难过]', '[疑问]', '[困]', '[么么哒]', '[憨笑]', '[衰]', '[撇嘴]',
    '[阴险]', '[奋斗]', '[发呆]', '[右哼哼]', '[抱抱]', '[坏笑]', '[鄙视]', '[晕]', '[可怜]', '[强]', '[弱]',
    '[握手]', '[胜利]', '[抱拳]', '[凋谢]', '[米饭]', '[蛋糕]', '[西瓜]', '[啤酒]', '[瓢虫]', '[勾引]', '[OK]',
    '[爱你]', '[咖啡]', '[刀]', '[差劲]', '[拳头]', '[心碎了]', '[太阳]', '[礼物]', '[皮球]', '[骷髅]', '[闪电]',
    '[饥饿]', '[困]', '[咒骂]', '[折磨]', '[抠鼻]', '[鼓掌]', '[糗大了]', '[左哼哼]', '[打哈欠]', '[快哭了]', '[吓]', '[篮球]',
    '[乒乓]', '[NO]', '[闭嘴]', '[猫咪]', '[红双喜]', '[鞭炮]', '[红灯笼]', '[麻将]', '[麦克风]', '[礼品袋]', '[信封]', '[象棋]', '[彩带]',
    '[蜡烛]', '[爆筋]', '[棒棒糖]', '[奶瓶]', '[面条]', '[香蕉]', '[飞机]', '[左车头]', '[车厢]', '[右车头]', '[多云]', '[下雨]', '[钞票]',
    '[熊猫]', '[灯泡]', '[风车]', '[闹钟]', '[雨伞]', '[彩球]', '[钻戒]', '[沙发]', '[纸巾]', '[手枪]', '[青蛙]']

let FACEICONS = [];
for (let i = 0; i < FACEICONSNAME.length; i++) {
    FACEICONS.push({ name: FACEICONSNAME[i], icon: require('../../images/emoji/' + FACEICONSNAME[i] + '@2x.png') });
}

const ICON_ADD = require('../../images/icons/ic_chat_additional.png');
const ICON_PIC = require('../../images/icons/ic_chat_image.png');



class MChatModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
        }
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onClickItem = (item) => {
        this._addFace(item);
        this.setState({ hasInput: true });
    }

    _addFace = (item) => {
        let img = document.createElement('img');
        img.setAttribute('src', item.icon);
        img.setAttribute('alt', item.name);
        img.setAttribute('width', 28);
        img.setAttribute('height', 28);
        img.setAttribute('style', 'vertical-align: middle');
        this.refs.textarea.appendChild(img);
    }

    _handleInputChange = (event) => {

    }

    _onChangeTab = (val) => {
        this.setState({ value: val });
    }

    _handleImage = (val) => {
        console.log(val);
    }

    render() {
        const { classes, open, isFile } = this.props;
        let { value } = this.state;
        let hasInput = this.refs.textarea && this.refs.textarea.childNodes && this.refs.textarea.childNodes.length > 0;
        if (!isFile) {
            hasInput = true;
        }
        return (
            <Modal
                open={open}
                hideBackdrop={true}
                onClose={() => this.props.onClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={classes.modal}
                style={{ position: 'fixed', top: 0, width: '100vw' }}
            >
                <Grid container direction='column' alignItems='center' style={{ width: '100vw', height: '100vh' }}>
                    <Grid container direction='column' alignItems='center' style={{ width: '100vw', height: '60vh' }}>
                        <ButtonBase disableRipple onClick={() => { this.props.onClose() }} style={{ width: '100%', height: '100%' }} />
                    </Grid>
                    <Grid container direction='column' alignItems='center' className={classes.pannel}>
                        <Grid container direction='row' alignItems='center' justify='space-between' style={{ marginTop: 8, width: '100%' }}>
                            <Grid container direction='row' alignItems='center' justify='space-between' className={classes.inputBg}>
                                <span ref="textarea" onInput={(e) => this._handleInputChange(e)} suppressContentEditableWarning className={classes.input} contentEditable={true} ></span>
                                <IconButton onClick={() => this._onChangeTab(0)} className={classes.iconButton}>
                                    <img src={ICON_FACE} style={{ width: 20, height: 20 }}></img>
                                </IconButton>
                            </Grid>
                            <Grid container direction='row' justify='center' style={{ width: 80 }}>
                                {
                                    hasInput && <ButtonBase onClick={() => this.props.onSendMsg(this.refs.textarea)} className={classes.sendButton}>发送</ButtonBase>
                                }
                                {
                                    isFile && !hasInput && <IconButton onClick={() => this._onChangeTab(1)}>
                                        <img src={ICON_ADD} style={{ width: 35, height: 35 }}></img>
                                    </IconButton>
                                }
                            </Grid>
                        </Grid>
                        {
                            value == 0 && <Grid container direction='row' alignItems='center' style={{ marginTop: 8, paddingLeft: 8, paddingRight: 8, overflowY: 'scroll', flex: 1 }}>
                                {
                                    FACEICONS.map((item, i) => (
                                        <IconButton onClick={() => this._onClickItem(item)} key={i} className={classes.faceIconButton}>
                                            <img src={item.icon} style={{ width: 28, height: 28 }}></img>
                                        </IconButton>
                                    ))
                                }
                            </Grid>
                        }
                        {
                            isFile && value == 1 && <Grid container direction='row' alignItems='center' style={{ marginTop: 8, paddingLeft: 8, paddingRight: 8 }}>
                                <ButtonBase disableRipple style={{ padding: 0, margin: 0 }} >
                                    <Grid container direction='column' alignItems='center' style={{ marginLeft: 8 }}>
                                        <Grid container direction='column' alignItems='center' justify='center'
                                            style={{ backgroundColor: '#F5F5F5', width: 60, height: 60, borderRadius: 5 }}>
                                            <img src={ICON_PIC} style={{ width: 21, height: 21 }}></img>
                                            <input onChange={(e) => this.props.sendImageMessage && this.props.sendImageMessage(e.target)} type='file' accept='image/*' style={{ position: 'absolute', opacity: 0 }} title=''  ></input>
                                        </Grid>
                                        <Typography style={{ fontSize: 12, color: '#0D0D0D', marginTop: 8 }}>照片</Typography>
                                    </Grid>
                                </ButtonBase>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Modal >
        );
    }
}

MChatModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSendMsg: PropTypes.func.isRequired,
    isFile: PropTypes.bool.isRequired,
    sendImageMessage: PropTypes.func,
}

export default withStyles((theme) => ({
    modal: {
        backgroundColor: 'transparent',
        width: '100vw',
        height: '40vh',
    },
    pannel: {
        width: '100%',
        height: '40vh',
        backgroundColor: '#FFF',
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: 20,
        height: 20,
    },
    faceIconButton: {
        padding: theme.spacing(0.5, 0.5, 0.5, 0.5),
        margin: theme.spacing(0.5, 0.5, 0.5, 0.5),
    },
    inputBg: {
        flex: 1,
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        height: 35,
        marginLeft: theme.spacing(1),
    },
    input: {
        flex: 1,
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        height: 30,
        outline: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        overflowX: 'scroll',
        overflowY: 'scroll',
        alignItems: 'center',
        lineHeight: 2.4,
        wordBreak: 'break-all',
    },
    sendButton: {
        backgroundColor: '#0D0D0D',
        fontSize: 12,
        color: '#FFF',
        width: 80,
        height: 35,
        borderRadius: 17.5,
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}))(MChatModal);